import { Link, NavLink } from "react-router-dom";

const linkCls = ({ isActive }) =>
  `text-[13px] font-mono-alt tracking-[0.18em] uppercase transition-colors ${
    isActive ? "text-white" : "text-white/50 hover:text-white"
  }`;

export default function Nav() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0A0B0E]/80 border-b border-white/[0.08]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="w-8 h-8 border border-white/20 flex items-center justify-center">
            <div className="w-2 h-2 bg-emerald-500 group-hover:bg-white transition-colors" />
          </div>
          <span className="font-display text-[15px] leading-none tracking-tight">
            PFAS<span className="text-white/50">·</span>RISK<span className="text-white/50">·</span>INTELLIGENCE
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/triage" className={linkCls} data-testid="nav-triage">Triage Tool</NavLink>
          <NavLink to="/checklist" className={linkCls} data-testid="nav-checklist">Checklist</NavLink>
          <NavLink to="/risk-screen" className={linkCls} data-testid="nav-risk-screen">Risk Screen</NavLink>
          <NavLink to="/portfolio-screening" className={linkCls} data-testid="nav-portfolio">Portfolio</NavLink>
          <NavLink to="/risk-watch" className={linkCls} data-testid="nav-risk-watch">Risk Watch</NavLink>
        </nav>
        <Link
          to="/risk-screen"
          data-testid="nav-cta-request"
          className="hidden sm:inline-flex items-center gap-2 bg-white text-[#0A0B0E] px-4 py-2 text-[12px] font-mono-alt tracking-[0.14em] uppercase hover-lift hover:bg-white/90"
        >
          Request Risk Screen
        </Link>
      </div>
    </header>
  );
}
